module.exports = __webpack_public_path__ + "img/BANNER_DASH_GREENN3.dc802c45.png";